import { b64ToBlob } from './helper/b64ToBlob';
import { DataService } from '../../services/data_service';
import { IDs } from '../IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';

interface WArchivImageProps extends React.ClassAttributes<any> {
    archivId: number;
    filePathDirect?: string;
    fixedHeight?: boolean;
    modul?: string;
    isLoaded?: (url: string, info: any) => void;
    size?: number;
    style?: React.CSSProperties;
}

interface WArchivImageState {
    b64: string;
    blob: any;
    error: string;
    info: any;
    url: string;
}

export class WArchivImage extends React.Component<WArchivImageProps, WArchivImageState> {
    constructor(props: any) {
        super(props);
        this.state = {
            b64: null,
            blob: null,
            error: null,
            info: null,
            url: null
        };
        this.getFileInfo = this.getFileInfo.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;

    private mimeTypes = ['image/gif', 'image/jpeg', 'image/png'];

    componentDidMount(): void {
        if (this.props.filePathDirect) {
            this.getFileInfo(this.props.filePathDirect, 'direct');
        } else if (this.props.archivId) {
            this.loadArchiv(this.props.archivId, this.getFileInfo);
        } else {
            this.setState({ info: undefined });
        }
    }

    getFileContent(path: string, mode: string, info: any): void {
        this.dataService.loadRessource(path, mode, (b64: string) => {
            b64ToBlob(b64, info.mime || null, (blob: any) => {
                const url: string = window.URL.createObjectURL(blob);
                this.setState({ b64, blob, url });

                if (this.props.isLoaded) {
                    this.props.isLoaded(url, info);
                }
            });
        }, this.props.modul);
    }

    getFileInfo(path: string, mode: string): void {
        this.dataService.getRessourceInfo(path, mode, (info: any) => {
            if (info) {
                this.setState({ info });
                this.getFileContent(path, mode, info);
            } else {
                this.setState({ error: 'Datei nicht verfügbar.' });
            }
        }, this.props.modul);
    }

    loadArchiv(archivId: number, callback: (path: string, mode: string) => void): void {
        this.dataService.loadDataForModul(
            IDs.ENT_ARCHIV_ITEMS,
            { tid: archivId },
            { resolve: true, fieldList: 'name, file' },
            this.props.modul ? this.props.modul : 'wips',
            (result: any) => {
                if ((result[IDs.ENT_ARCHIV_ITEMS] || []).length) {
                    let fileName: string = result[IDs.ENT_ARCHIV_ITEMS][0].file || '';

                    if (fileName.substr(0, 11) === 'wips3_2013/') {
                        fileName = fileName.substr(11);
                    }
                    callback(fileName, 'archiv');
                } else {
                    this.setState({ error: 'Datei nicht verfügbar.' });
                }
            }
        );
    }

    render(): JSX.Element {
        if (this.state.error) {
            return (
                <span style={{ color: 'red', fontStyle: 'italic' }}>
                    {this.state.error}
                </span>
            );
        } else if (this.state.info) {
            return this.mimeTypes.indexOf(this.state.info.mime || null) !== -1
                ? this.renderImage()
                : null;
        } else if (this.state.info === undefined) {
            return null;
        }
        return <i>Lade...</i>;
    }

    renderImage(): JSX.Element {
        const { fixedHeight, size } = this.props;
        const height: number = (fixedHeight && size) ? size : null;
        const max: number = (!fixedHeight && size) ? size : null;

        return (
            <img
                src={this.state.url || null}
                style={{
                    ...(max ? { maxWidth: max } : {}),
                    ...(height ? { height } : {}),
                    ...(max ? { maxHeight: max } : {}),
                    ...this.props.style
                }}
            />
        );
    }
}
